// Navbar.js - Creative Floating Design
import React from "react";
import {
  AppBar,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import DrawerComponent from "./Drawer";
import { Link } from "react-router-dom";
import "./Navbar.css"; // Import the creative styles

const Navbar = () => {
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <React.Fragment>
      <AppBar position="fixed" className="navbar-glass">
        <Toolbar>
          {/* Logo Section */}
          <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
            <img className="brand-logo" src="./images/dbase.png" alt="logo" style={{ maxWidth: '250px', height: 'auto' }} />
          </Link>

          {isMatch ? (
            <>
              <DrawerComponent />
            </>
          ) : (
            <>
              {/* Desktop Links with Liquid Hover */}
              <div style={{ marginLeft: "auto", display: "flex", gap: "20px", alignItems: "center" }}>
                <Link to="/" className="nav-link">HOME</Link>
                <Link to="/about" className="nav-link">ABOUT US</Link>
                <Link to="/products" className="nav-link">PRODUCTS</Link>
                <Link to="/clientele" className="nav-link">CLIENTELE</Link>
                <Link to="/contact" className="nav-link">CONTACT US</Link>
              </div>
            </>
          )}
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
};

export default Navbar;

